import type { PropsWithChildren } from "react";
import { useMerchantNavigationSections } from "@/components/sidebar/merchant-sidebar-items";
import type { DashboardTab } from "@/lib/schema";
import { Layout } from "./layout";

export const DashboardLayout = ({ page, children }: { page: DashboardTab } & PropsWithChildren) => {
  const sections = useMerchantNavigationSections();
  return (
    <Layout activeTab={page} sections={sections}>
      {children}
    </Layout>
  );
};
